import type { TenantConfig } from '@360dash/shared'
import sitethreesixtyConfig from '../../../../tenants/sitethreesixty.json'

const tenantConfig = sitethreesixtyConfig as TenantConfig

export function getTenantConfig(): TenantConfig {
  return tenantConfig
}

export function isModuleEnabled(moduleKey?: string): boolean {
  if (!moduleKey) return true
  return Boolean(tenantConfig.modules[moduleKey])
}
